<div [formGroup]="customerForm" class="customer-details">
  <!-- Registering As -->
  <div class="form-section">
    <h3>Who are you registering?</h3>
    <mat-radio-group formControlName="registeringAs" class="radio-group">
      <mat-radio-button value="individual">Individual</mat-radio-button>
      <mat-radio-button value="company">Company</mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Company Details (only if company is selected) -->
  @if (isCompanySelected()) {
    <div formGroupName="companyDetails" class="form-section">
      <h3>Company Details</h3>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Company Name</mat-label>
          <input matInput formControlName="companyName" [matAutocomplete]="auto" required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompanyName" (optionSelected)="onOptionSelected($event.option.value)">
            @if (fetchingCompanyDetails()) {
              <mat-option style="padding-left: 40%;">
                <mat-spinner diameter="30"></mat-spinner>
              </mat-option>
            }
            @for (option of filteredOptions() | async; track option.number) {
              <mat-option [value]="option">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (customerForm.get('companyDetails.companyName')?.hasError('required')) {
            <mat-error>
              Company name is required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Contact</mat-label>
          <mat-select formControlName="contact" (selectionChange)="onContactSelected($event.value)" [disabled]="!selectedCompany() || fetchingPersonnel()">
            @if (fetchingPersonnel()) {
              <mat-option disabled>
                <mat-spinner diameter="20"></mat-spinner>
                Loading contacts...
              </mat-option>
            } @else {
              @for (contact of contactOptions(); track contact.id) {
                <mat-option [value]="contact.id">
                  {{ contact.displayName }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (customerForm.get('companyDetails')?.hasError('companyNotSelected')) {
          <div class="add-company-link">
            <span class="link-text" (click)="openAddCompanyDialog()">
              Can't find your company? Click here to add
            </span>
          </div>
      }
    </div>
  }

  <!-- Personal Details -->
  <div formGroupName="personalDetails" class="form-section">
    <h3>Personal Details</h3>
    <div class="form-row mb">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required>
        @if (customerForm.get('personalDetails.firstName')?.hasError('required')) {
          <mat-error>
            First name is required
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" >
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        @if (customerForm.get('personalDetails.lastName')?.hasError('required')) {
          <mat-error>
            Last name is required
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row mb">
      <mat-form-field appearance="outline" >
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email">

        @if (showCompanyEmailHint()) {
            <mat-hint class="email-domain"> 
              Please use the email address associated with the company 
            </mat-hint>
        }
        
        @if (customerForm.get('personalDetails.email')?.hasError('required')) {
          <mat-error>
            Email is required
          </mat-error>
        }
        @if (customerForm.get('personalDetails.email')?.hasError('email')) {
          <mat-error>
            Please enter a valid email address
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" >
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone" required>
        @if (customerForm.get('personalDetails.phone')?.hasError('required')) {
          <mat-error>
            Phone number is required
          </mat-error>
        }
        @if (customerForm.get('personalDetails.phone')?.hasError('pattern')) {
          <mat-error>
            Please enter a valid UK phone number
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
